import React, {Component} from "react";
import {connect} from "react-redux";
import Popup from "reactjs-popup";
import Axios from "axios";
import getAxiosConfig from "../../utils/axiosConfig";
import messageCodes from "../../utils/messageCodes";
import urlList from "../../reducers/propertiesReducer";
import {checkIfFieldValid, REGEX} from "../../utils/common";
import {showToastForBackend, showToastForFrontend} from '../../actions/toastActions'
import {FormattedMessage} from 'react-intl';
import {
    createTheme,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    TableCell,
    TableRow,
    ThemeProvider
} from "@mui/material";

class User extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.id,
            name: this.props.name,
            newName: this.props.name,
            email: this.props.email,
            newEmail: this.props.email,
            newPassword: "",
            isAdmin: this.props.isAdmin,
            newIsAdmin: this.props.isAdmin,
            isActive: this.props.isActive,
            newIsActive: this.props.isActive,
            privileges: this.props.privileges,
            selectedPrivileges: JSON.parse(this.props.privileges),
            passwordExpireAfter: this.props.passwordExpireAfter,
            newPasswordExpireAfter: this.props.passwordExpireAfter,
            confirmDelete: false,
            open: false,
            emailError: false
        };

        this.deleteUser = this.deleteUser.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.switchConfirmDelete = this.switchConfirmDelete.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection(element, value) {
        this.setState((prevState) => ({
            selectedPrivileges: {
                ...prevState.selectedPrivileges,
                [element]: value,
            },
        }));

    }

    deleteUser(event) {
        event.preventDefault();
        Axios.delete(
            `${urlList().userManagementUrl}/${this.state.id}`,
            getAxiosConfig()
        ).then((response) => {
            if(response) {
                this.props.updateUsers().then(
                    () => {this.setState({isActive: this.props.isActive})}
                );
            }
        })
        .catch(err => {
            if (err.response)
                this.props.showToastForBackend(err.response.data);
            else
                this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR)
        });
    }

    updateUser(event) {
        event.preventDefault();
        if (!this.state.newName ||
            checkIfFieldValid(this.state.newEmail, REGEX.EMAIL))
            return;
        
        Axios.put(
            `${urlList().userManagementUrl}/${this.state.id}`,
            {
                id: this.state.id,
                name: this.state.newName ? this.state.newName : this.state.name,
                email: this.state.newEmail ? this.state.newEmail : this.state.email,
                isAdmin: this.state.newIsAdmin,
                privileges: this.state.selectedPrivileges ? JSON.stringify(this.state.selectedPrivileges) : this.state.privileges,
                isActive: this.state.newIsActive ? 1 : 0,
                password: this.state.newPassword.trim() ? this.state.newPassword.trim() : null,
                passwordExpireAfter: this.state.newPasswordExpireAfter ? this.state.newPasswordExpireAfter : this.state.passwordExpireAfter
            },
            getAxiosConfig()
        ).then((response) => {
            if(response) {
                this.setState({
                    emailError: false,
                    open: false,

                    name: this.state.newName,
                    email: this.state.newEmail,
                    isAdmin: this.state.newIsAdmin,
                    isActive: this.state.newIsActive,
                    passwordExpireAfter: this.state.newPasswordExpireAfter,
                    password: this.setState.password
                });
            }
        })
        .catch(err => {
            if (err.response)
                this.props.showToastForBackend(err.response.data);
            else
                this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR)

            this.setState({
                emailError: true,
                open: true,
            });
        });
    }

    handleChange({target}) {
        if (target.type === "checkbox") {
            this.setState({[target.name]: target.checked});
        } else {
            this.setState({[target.name]: target.value});
        }
        if (target.name === 'newIsAdmin' && target.checked) {
            let adminPrivileges = {};
            this.props.navigation.mainNavigation.forEach((element) => {
                adminPrivileges[element.title] = "write";
            });
            this.setState({
                selectedPrivileges: adminPrivileges
            });
        }
    }

    openModal() {
        this.setState({open: true});
    }

    closeModal() {
        this.setState({open: false, newPassword: ""});
        this.props.updateUsers();
    }

    switchConfirmDelete() {
        this.setState({confirmDelete: !this.state.confirmDelete});
    }

    render() {
        const theme = createTheme({
            palette: {
                primary: {
                    main: '#86BC25FF',
                },
            },
        });

        const contentStyle = {
            width: "60%"
        };

        let confirmButton;
        let deleteButton;
        if (localStorage.getItem('user') !== this.state.email) {
            if (!this.state.confirmDelete) {
                confirmButton = <button className="user-delete-btn" onClick={this.switchConfirmDelete}>
                    <FormattedMessage id="Delete"/>
                </button>
            } else {
                confirmButton = <button className="user-delete-btn" onClick={this.switchConfirmDelete}>
                    <FormattedMessage id="Cancel Delete"/>
                </button>
                deleteButton = <button className="user-delete-btn" onClick={this.deleteUser}>
                    <FormattedMessage id="Confirm Delete"/>
                </button>
            }
        }

        return (
            <TableRow>
                <TableCell className="table-row">{this.state.id}</TableCell>
                <TableCell className="table-row">{this.state.name}</TableCell>
                <TableCell className="table-row">{this.state.email}</TableCell>
                <TableCell className="table-row">{this.state.isAdmin.toString()}</TableCell>
                <TableCell className="table-row">{(!!this.state.isActive).toString()}</TableCell>
                <TableCell className="button-group">
                    <button className="user-update-btn" onClick={this.openModal}>
                        <FormattedMessage id="Update"/>
                    </button>
                    {confirmButton}
                    {deleteButton}
                </TableCell>
                <Popup
                    open={this.state.open}
                    contentStyle={contentStyle}
                    modal
                    closeOnDocumentClick
                    onClose={this.closeModal}
                >
                    <div className="header"><FormattedMessage id="Update User"/></div>
                    <div className="content">
                        <form className="form" onSubmit={this.updateUser}>
                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Name"/></div>
                                <input
                                    name="newName"
                                    value={this.state.newName}
                                    onChange={this.handleChange}
                                    className={checkIfFieldValid(this.state.newName) ? 'user-input-invalid' : 'user-input'}
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Email"/></div>
                                <input
                                    name="newEmail"
                                    value={this.state.newEmail}
                                    onChange={this.handleChange}
                                    className={(checkIfFieldValid(this.state.newEmail, REGEX.EMAIL)) ? 'user-input-invalid' : 'user-input'}/>
                            </div>

                            {this.state.emailError &&
                                <div className="form-row"><span className='custom-email-error data-field-invalid'>Email already exists.</span></div>
                            }

                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Password"/></div>
                                <input
                                    name="newPassword"
                                    value={this.state.newPassword}
                                    onChange={this.handleChange}
                                    className='user-input'
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Password expire after(days)"/></div>
                                <input
                                    className="user-input"
                                    name="newPasswordExpireAfter"
                                    value={this.state.newPasswordExpireAfter}
                                    onChange={this.handleChange}
                                />
                            </div>

                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Admin"/></div>
                                <div className="checkbox-container">
                                    <input
                                        className="checkbox"
                                        name="newIsAdmin"
                                        type="checkbox"
                                        defaultChecked={this.state.newIsAdmin}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-label"><FormattedMessage id="Active"/></div>
                                <div className="checkbox-container">
                                    <input
                                        className="checkbox"
                                        name="newUserIsActive"
                                        type="checkbox"
                                        defaultChecked={this.state.newIsActive}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>


                            {!this.state.newIsAdmin && (
                                <div className="form-row">
                                    <div className="form-label"><FormattedMessage id="Privileges"/></div>
                                    <div className="privilege-container">
                                        {this.props.navigation.mainNavigation.map((element, index) => (
                                            <div className="privilege-selection" key={index}>
                                                <ThemeProvider theme={theme}>
                                                    <div style={{width: '100%'}}>
                                                        <FormControl component="fieldset"
                                                                     sx={{flexDirection: 'row', alignItems: 'center', width: '100%'}}>
                                                            <div className="radio-label"><FormLabel component="legend">{element.title}</FormLabel></div>
                                                            <div className="radio-group">
                                                                <RadioGroup
                                                                    sx={{flexDirection: 'row'}}
                                                                    aria-label={element.title}
                                                                    name={element.title}
                                                                    value={this.state.selectedPrivileges[element.title] || "read-only"}
                                                                    onChange={(event) => this.handleSelection(element.title, event.target.value)}
                                                                >
                                                                    <FormControlLabel value="no access"
                                                                                      control={<Radio/>}
                                                                                      label="no access"
                                                                                      sx={{visibility: element.title === 'Analytics' ? 'hidden' : 'visible',}}/>
                                                                    <FormControlLabel value="read-only"
                                                                                      control={<Radio/>}
                                                                                      label="read-only"/>
                                                                    <FormControlLabel value="write"
                                                                                      control={<Radio/>}
                                                                                      label="write"/>
                                                                </RadioGroup>
                                                            </div>
                                                        </FormControl>
                                                    </div>
                                                </ThemeProvider>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="button-container">
                                <button
                                    className="save-btn"
                                    onClick={this.updateUser}
                                    disabled={!this.state.name}>
                                    <FormattedMessage id="Save"/>
                                </button>
                            </div>
                        </form>
                    </div>
                </Popup>
            </TableRow>
        )
    }
}

function mapStateToProps(state) {
    return {
        navigation: state.navigation,
        properties: state.properties
    };
}

export default connect(mapStateToProps, {showToastForFrontend, showToastForBackend})(User);
